import React from 'react';
import Tooltip from '../../../shared/Tooltip';

export default function ApplicationStatus({ app }) {
  if (app.status === 'new')
    return (
      <div>
        Application Status:{' '}
        <Tooltip
          tooltip_text="Borrowers receive this status if they never completed the application flow, they had a pending application that was never resolved or they were declined over 6 months ago. If the borrower were to apply again, their application would be treated as a new, first-time application."
          trigger_class="cursor-pointer ml-1.5 font-avenir-book capitalize"
          container_class="normal-case text-center p-4 px-6 text-sm text-navy-blue bg-light-blue max-w-md font-avenir-book"
        >
          {app.status}
        </Tooltip>
      </div>
    );

  if (app.tier === 'Z') {
    let tooltip = (
      <div>
        <p className='capitalize'>Original Status: {app.status}</p>
        <p>NetX applicants are auto-declined</p>
      </div>
    );

    return (
      <div>
        Application Status:{' '}
        <Tooltip
          tooltip_text={tooltip}
          trigger_class="cursor-pointer ml-1.5 font-avenir-book capitalize"
          container_class="normal-case text-center p-4 px-6 text-sm text-navy-blue bg-light-blue max-w-md font-avenir-book whitespace-pre-line"
        >
          Auto-Declined
        </Tooltip>
      </div>
    );
  }

  return <div>Application Status: {app.status}</div>;
}
